const Footer = () => (
  <footer className="py-8">
    <p className="font-playfair text-center text-yellow">
      Copyright ©2022. All Rights Reserved.
      {' '}
      {' '}
      <br />
      Designed by Levy
    </p>
  </footer>
);

export default Footer;
